<template>
  <div class="card-content">
    <b-table :data="lignesCommandeTlpe"
             :bordered="true"
             :striped="true">
      <b-table-column field="codeMateriel"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.codeMateriel')"
                      v-slot="props">
        <b-input v-model="props.row.code" disabled v-if="!props.row.total && props.row.total !== 0">
        </b-input>
      </b-table-column>
      <b-table-column field="adresse"
                :label="$t('editCommandeTlpe.infoMateriel.tab.adresse')"
                v-slot="props">
      <b-input v-model="props.row.libelle" v-if="!props.row.total && props.row.total !== 0">
      </b-input>
      </b-table-column>
      <b-table-column field="descriptionTlpe"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.descriptionTlpe')"
                      v-slot="props">
        <b-select v-if="!props.row.total && props.row.total !== 0"
          v-model="props.row.designationTlpe" expanded>
          <option v-for="description in constantes.LISTE_DESCRIPTION_TLPE"
                  :value="description.code" :key="description.code">
            {{ $t(description.libelle) }}
          </option>
        </b-select>
      </b-table-column>
      <b-table-column field="date"
                      v-if="commandeTlpe.typeDeclaration !== constantes.MATERIEL_EN_PLACE
                        && !isDeclarationAuFilDeLeau"
                      v-slot="props"
                      :label="getLabelDate">
        <b-datepicker v-if="!props.row.total"
                      show-week-number
                      nearby-selectable-month-days
                      v-model="props.row.date"
                      icon="calendar-today"
                      :editable="true">
        </b-datepicker>
      </b-table-column>
      <b-table-column field="dateDebut"
                      v-if="isDeclarationAuFilDeLeau"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.dateDebut')">
        <b-datepicker v-if="!props.row.total" show-week-number
                      nearby-selectable-month-days
                      v-model="props.row.date"
                      icon="calendar-today"
                      :editable="true">
        </b-datepicker>
      </b-table-column>
      <b-table-column field="dateFin"
                      v-if="isDeclarationAuFilDeLeau"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.dateFin')">
        <b-datepicker v-if="!props.row.total" show-week-number
                      nearby-selectable-month-days
                      v-model="props.row.dateFin"
                      icon="calendar-today"
                      :editable="true">
        </b-datepicker>
      </b-table-column>
      <b-table-column field="numerique"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.numerique')"
                      v-slot="props">
        <div class="has-text-centered mgt-7px">
          <qd-checkbox v-if="!props.row.total && props.row.total !== 0"
           v-model="props.row.numerique">
          </qd-checkbox>
        </div>
      </b-table-column>
      <b-table-column field="nbFace"
                      class="has-text-right"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.nbFace')">
        <b-input v-if="!props.row.total && props.row.total !== 0"
         type="number" v-model="props.row.nbFacesDeclarees"
          @input="updateCalculAuto(props.row)">
        </b-input>
      </b-table-column>
      <b-table-column field="superficie"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.superficie')">
        <b-input v-if="!props.row.total && props.row.total !== 0"
         type="number" v-model="props.row.surfaceUnitaire"
          @input="updateCalculAuto(props.row)">
        </b-input>
      </b-table-column>
      <b-table-column field="calaculAuto"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.calaculAuto')">
        <qd-switch v-if="!props.row.total &&
        props.row.total !== 0" @input="updateCalculAuto(props.row)"
                   class="mgr-0 mgt-7px"
                   v-model="props.row.lignesCommande[0].calculAutomatiqueTlpe">
        </qd-switch>
      </b-table-column>
      <b-table-column field="quantite"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.quantite')">
        <input-currency v-if="!props.row.total && props.row.total !== 0"
          isNumber="true" v-model="props.row.lignesCommande[0].quantite">
        </input-currency>
      </b-table-column>
      <b-table-column field="prixUnitaire"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.prixUnitaire')">
        <input-currency v-if="!props.row.total && props.row.total !== 0"
          isNumber="true" v-model="props.row.lignesCommande[0].prixUnitaire"
          :disabled="props.row.lignesCommande[0].calculAutomatiqueTlpe === true">
        </input-currency>
      </b-table-column>
      <b-table-column field="montantBrut"
                      v-slot="props"
                      :label="$t('editCommandeTlpe.infoMateriel.tab.montantBrut')">
        <div class="is-pulled-right" v-if="props.row.total !== undefined">
            {{ props.row.total | formatDevise }}
        </div>
        <input-currency v-else isNumber="true" :value="getMontantBrut(props.row)" :disabled="true">
        </input-currency>
      </b-table-column>
      <b-table-column field="delete"
                      v-slot="props">
        <a @click="removeLigne(props.row.id)" class="has-text-centered"
        v-if="!props.row.total && props.row.total !== 0">
          <b-icon
            class="mgt-5px"
            icon="delete-forever"
            type="is-danger">
          </b-icon>
        </a>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>

import {
  DEMONTAGES_ANNEE_PREC,
  MATERIEL_EN_PLACE,
  LISTE_DESCRIPTION_TLPE,
  LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU,
} from '@/configuration/gabed/tlpe/tlpeConf';
import calculPrixUnitaireAuto from '@/services/gabed/declaration/calculPrixUnitaireAuto';
import inputCurrency from '@/components/general/inputCurrency';
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
  data() {
    return {
      constantes: {
        MATERIEL_EN_PLACE,
        LISTE_DESCRIPTION_TLPE,
      },
    };
  },
  computed: {
    getLabelDate() {
      if (this.commandeTlpe.typeDeclaration === DEMONTAGES_ANNEE_PREC) {
        return this.$i18n.t('editCommandeTlpe.infoMateriel.tab.dateSuppression');
      }
      return this.$i18n.t('editCommandeTlpe.infoMateriel.tab.dateCreation');
    },
    isDeclarationAuFilDeLeau() {
      return !!LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU
        .map(i => i.code)
        .includes(this.commandeTlpe.typeDeclaration);
    },
    lignesCommandeTlpe() {
      return this.commandeTlpe.lignesCommande.concat([{ total: this.totalHt }]);
    },
    totalHt() {
      return calculArrondi(this.commandeTlpe.lignesCommande
        .reduce((acc, val) => acc + val.lignesCommande[0].totalHtAvecLigneRemise, 0));
    },
  },
  methods: {
    removeLigne(id) {
      const index = this.commandeTlpe.lignesCommande.findIndex((l) => {
        return l.id === id;
      });
      this.commandeTlpe.lignesCommande.splice(index, 1);
    },
    getMontantBrut(row) {
      const montant = calculArrondi(Number(
        row.lignesCommande[0].prixUnitaire
        * row.lignesCommande[0].quantite), 2);
      row.lignesCommande[0].totalHtAvecLigneRemise = montant;
      return montant;
    },
    updateCalculAuto(row) {
      const ligne = row.lignesCommande[0];
      if (!ligne.calculAutomatiqueTlpe) return;
      row.lignesCommande[0].prixUnitaire = calculArrondi(calculPrixUnitaireAuto(
        row.nbFacesDeclarees,
        row.surfaceUnitaire,
        row.prorataTemporis,
        row.tarifM2Annuel,
      ), 5);
    },
  },
};

</script>
